import type { WidgetToEmbedMessage } from "@babackapp/return-widget-components/types/shop-now";

export function postToParent(msg: WidgetToEmbedMessage): void {
  window.parent.postMessage(msg, "*");
}
